.container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: none;
}

.container:focus {
  outline: 2px solid var(--aura-color-global-border-strong);
  outline-offset: 2px;
}

.canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
}

.blurLayer {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
  backdrop-filter: var(--particle-blur, none);
  -webkit-backdrop-filter: var(--particle-blur, none);
}

.backgroundLayer {
  position: absolute;
  inset: 0;
  z-index: -1;
}

.contentLayer {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
}

/* Compatibility for content authored against the former dark media-panel
   recipe. Keep the override signature-specific: an ordinary black utility can
   still be used as a non-glass scrim, while a black utility combined with a
   backdrop utility is normalized to the neutral Liquid Glass material. */
.contentLayer
  :is(
    [class~="glass-bg-black/20"],
    [class~="glass-bg-black/30"],
    [class~="glass-bg-black/35"],
    [class~="glass-bg-black/45"]
  ):is(
    [class~="glass-backdrop-blur"],
    [class~="glass-backdrop-blur-sm"],
    [class~="glass-backdrop-blur-md"],
    [class~="glass-backdrop-blur-lg"],
    [class~="glass-backdrop-blur-xl"],
    [class~="glass-backdrop-blur-2xl"]
  ) {
  --glass-theme-text: rgba(var(--glass-color-black) / 0.9);
  --glass-text-primary: rgba(var(--glass-color-black) / 0.9);
  --glass-text-secondary: rgba(var(--glass-color-black) / 0.7);
  --glass-text-tertiary: rgba(var(--glass-color-black) / 0.5);
  background: var(--glass-gradient-neutral);
  border-color: var(--glass-border-subtle);
  color: var(--glass-text-primary) !important;
  backdrop-filter: blur(var(--glass-blur-md, 24px)) var(--glass-filter-base);
  -webkit-backdrop-filter: blur(var(--glass-blur-md, 24px))
    var(--glass-filter-base);
}

.contentLayer
  :is(
    [class~="glass-bg-black/20"],
    [class~="glass-bg-black/30"],
    [class~="glass-bg-black/35"],
    [class~="glass-bg-black/45"]
  ):is(
    [class~="glass-backdrop-blur"],
    [class~="glass-backdrop-blur-sm"],
    [class~="glass-backdrop-blur-md"],
    [class~="glass-backdrop-blur-lg"],
    [class~="glass-backdrop-blur-xl"],
    [class~="glass-backdrop-blur-2xl"]
  )
  :is(
    [class~="glass-text-white"],
    [class~="glass-text-white/70"],
    [class~="glass-text-white/75"],
    [class~="glass-text-white/80"],
    [class~="glass-text-white/85"],
    [class~="glass-text-white/90"]
  ) {
  color: var(--glass-text-secondary) !important;
}

.contentLayer
  :is(
    [class~="glass-bg-black/20"],
    [class~="glass-bg-black/30"],
    [class~="glass-bg-black/35"],
    [class~="glass-bg-black/45"]
  ):is(
    [class~="glass-backdrop-blur"],
    [class~="glass-backdrop-blur-sm"],
    [class~="glass-backdrop-blur-md"],
    [class~="glass-backdrop-blur-lg"],
    [class~="glass-backdrop-blur-xl"],
    [class~="glass-backdrop-blur-2xl"]
  )
  :is(h1, h2, h3, h4, h5, h6) {
  color: var(--glass-text-primary) !important;
}
